module.exports = __webpack_public_path__ + "img/60.3c1b4d87.jpg";